import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const zeroeldConfig: TSPConfig = {
  key: 'zeroeld',
  name: 'Zero ELD',
  imageName: 'ZeroELD',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the company ID from your Zero ELD profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default zeroeldConfig;
